export default __webpack_public_path__ + "static/media/cosmetics2.5904caa7.jpg";